<template>
  <v-layout row wrap justify-center align-center>

    <confirmation
      :isShow ="showconfirmation"
      @cancelar="confirmationCancelar()"
      @confirmar="confirmationConfirmar()"
      @fechar="confirmationCancelar()"
    ></confirmation>
    
    <!-- COMEÇO EDIÇÃO -->
    <v-dialog v-model="isediting" v-if="isediting" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{selected.aluno.first_name + ' ' +
                                    selected.aluno.last_name}} </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-textarea
                  box
                  name="ativ_planejada"
                  v-model="selected.ativ_planejada"
                  label="Atividade Planejada"
                  value=""
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  box
                  name="ativ_ocorrida"
                  v-model="selected.ativ_ocorrida"
                  label="Atividade Ocorrida"
                  value=""
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  box
                  name="comentario"
                  v-model="selected.comentario"
                  label="Comentário"
                  value=""
                ></v-textarea>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="isediting = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" flat @click.native="saveDetails(selected)">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM EDITANDO -->
    
    <!-- REAGENDAMENTO INDIVIDUAL -->
    <v-dialog v-model="isrescheduling" v-if="isrescheduling" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{selected.aluno.first_name + ' ' +
                                    selected.aluno.last_name}} </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm5>
                      <v-menu
                        ref="menu3"
                        :close-on-content-click="false"
                        v-model="menu3"
                        :nudge-right="40"
                        :return-value.sync="rescheduleinfo.date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="dateFormatted"
                          label="Data"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="rescheduleinfo.date" 
                        locale="pt-br"
                        @input="$refs.menu3.save(rescheduleinfo.date)"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex sm5>
                      <v-menu
                        ref="menu4"
                        :close-on-content-click="false"
                        v-model="menu4"
                        :nudge-right="40"
                        :return-value.sync="rescheduleinfo.time"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="rescheduleinfo.time"
                          label="Hora"
                          prepend-icon="access_time"
                          readonly
                        ></v-text-field>
                        <v-time-picker v-model="rescheduleinfo.time"
                        min="7:00"
                        max="19:59"
                        format="24hr"
                        @change="$refs.menu4.save(rescheduleinfo.time)"></v-time-picker>
                      </v-menu>
                    </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="isrescheduling = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" flat @click.native="saveReschedule()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM REAGENDAMENTO INDIVIDUAL -->
    

    <v-dialog
      v-model="showModal"
      scrollable
      max-width="800px"
    >
          <v-card>
            <v-card-title class="headline">
              {{contextEvent.title}} - 
              {{contextEvent.start | moment("DD/MM/YYYY H:mm")}} 
              até {{contextEvent.end | moment("H:mm")}}
            </v-card-title>

            <v-card-text style="height: 300px;">
              <v-container fluid>
                <v-layout row 
                  align-content-center
                  centered>
                      <v-data-table
                        style="width: 100%"
                        :items="contextEvent.detalhes"
                        :headers="[{text:'Mediador', value:'Mediador'},
                        {text:'Aluno', value:'Aluno'},
//                        {text:'Planejado', value:'Planejado'},
  //                      {text:'Ocorrido', value:'Ocorrido'},
    //                    {text:'Comentário', value:'Comentário'},
                        {text:'Ações', value:'Acoes'},
                        ]"
                        hide-actions
                        class="elevation-1"
                      >
                        <template slot="items" slot-scope="props">
                          <tr @click="props.expanded = !props.expanded">
                          <td>{{ props.item.mediador.first_name + ' ' + props.item.mediador.last_name  }}</td>
                          <td>{{ props.item.aluno.first_name }}</td>
                          <!-- <td>{{ props.item.ativ_planejada }}</td>
                          <td>{{ props.item.ativ_ocorrida }}</td>
                          <td>{{ props.item.comentario }}</td> -->
                          <td>
                            <v-icon
                              small
                              class="mr-2"
                              @click="startEdit(props.item)"
                            >
                              edit
                            </v-icon>
                            <v-icon
                              small
                              @click="startReschedule(props.item)"
                            >
                              access_time
                            </v-icon>
                          </td>
                          </tr>
                        </template>
                        <template slot="expand" slot-scope="props">
                          <v-card flat>
                            <v-card-text>
                              <p> <b> Atividade Planejada:</b> {{props.item.ativ_planejada}} </p>
                              <p> <b> Atividade Ocorrida:</b> {{props.item.ativ_ocorrida}} </p>
                              <p> <b> Comentário:</b> {{props.item.comentario}} </p>
                              </v-card-text>
                          </v-card>
                        </template>
                      </v-data-table>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div  v-if='canReschedule' class="pull-left">
                <div v-if='reschedulingall'>
                  <v-layout row> 
                    <v-flex sm5>
                      <v-menu
                        ref="menu2"
                        :close-on-content-click="false"
                        v-model="menu2"
                        :nudge-right="40"
                        :return-value.sync="rescheduleinfo.date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="dateFormatted"
                          label="Data"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="rescheduleinfo.date" 
                        locale="pt-br"
                        @input="$refs.menu2.save(rescheduleinfo.date)"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex sm5>
                      <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        :return-value.sync="rescheduleinfo.time"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="rescheduleinfo.time"
                          label="Hora"
                          prepend-icon="access_time"
                          readonly
                        ></v-text-field>
                        <v-time-picker v-model="rescheduleinfo.time"
                        min="7:00"
                        max="19:59"
                        format="24hr"
                        @change="$refs.menu.save(rescheduleinfo.time)"></v-time-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </div>
            </div>
            <v-spacer />
            <div  v-if='canReschedule' class="pull-right">     
                <v-btn v-if='!reschedulingall'
                color="blue darken-1" flat
                @click="reschedulingall=true">Reagendar Todos</v-btn>
                <v-btn v-if='reschedulingall'
                color="red darken-1" flat
                @click="reschedulingall=false">Cancelar</v-btn>
                <v-btn v-if='reschedulingall'
                color="green darken-1" flat
                @click="rescheduleClass(contextEvent)">Salvar</v-btn>
            </div>
            </v-card-actions>
          </v-card>

    </v-dialog>


    <v-flex xs-12>
        <v-card>
          <v-card-title>
            <h1>{{pageTitle}}</h1>
          </v-card-title>
          <v-card-text>
            <full-calendar ref="calendar" 
              :event-sources="eventSources" 
              :config="configuracao"  
              @event-selected="eventSelected">
            </full-calendar>
          </v-card-text>
        </v-card>
    </v-flex>

  </v-layout>
</template>
<script>
import api from '@/api'
import CardAluno from './componentes/CardAluno.vue'
import Confirmation from './confirmation.vue'

export default {
  name: 'Calendario',
  components: {
    CardAluno,
    Confirmation
  },
  data () {
    return {
      showModal: false,
      showconfirmation: false,
      contextAula: {},
      contextEvent: {},
      reschedulingDetail: null,
      events: [],
      isediting: false,
      isrescheduling: false,
      tempData: {},
      reschedulingall: false,
      rescheduleinfo: {},
      dateFormatted: '',
      selected: {},

      configuracao: {
        locale: 'pt-br',
        editable: false,
        aspectRatio: 1.35,
        defaultView: 'month',
        header: {
          left: 'title',
          center: '',
          right: 'agendaDay,agendaWeek,month today prev,next'
        },
        views: {
          week: {
            columnFormat: 'ddd D/M'
          }
        },
        buttonText: {
          today: 'Hoje',
          month: 'Mês',
          week: 'Semana',
          day: 'Dia',
          list: 'Lista'
        }

      }
    }
  },
  watch: {
    rescheduleinfo (val) {
      this.dateFormatted = this.formatDate(this.rescheduleinfo.date)
    }
  },
  computed: {
    canSeeComment () {
      if (this.$store.state.selectedRole) {
        if (this.$store.state.selectedRole.permissions.length === 0) {
          return false
        } else {
          return ((this.$store.state.selectedRole.permissions
                .includes('atividades | aula | Can see comments')))
        }
      }
    },
    canEdit () {
      if (this.$store.state.selectedRole) {
        if (this.$store.state.selectedRole.permissions.length === 0) {
          return false
        } else {
          return ((this.$store.state.selectedRole.permissions
                .includes('atividades | aula | Can change aula')))
        }
      }
    },
    canReschedule () {
    //   const slug = this.$route.params.slug
    //   const tipo = this.$route.params.tipo

      if (this.$store.state.selectedRole) {
        if (this.$store.state.selectedRole.permissions.length === 0) {
          return false
        } else {
          return this.$store.state.selectedRole.permissions.includes('core | Usuário | can reschedule classes')
        }
      }
    },
    pageTitle () {
      if (this.$route.params.tipo === 'usuario') {
        return 'Calendário de Atividades do Usuário - ' + this.$route.params.slug
      }
      if (this.$route.params.tipo === 'unidade') {
        return 'Calendário de Atividades da Unidade'
      }
      if (this.$route.params.tipo === 'turma') {
        return 'Calendário de Atividades da Turma'
      }
    },
    eventSources () {
      const slug = this.$route.params.slug
      const tipo = this.$route.params.tipo
      if (tipo === 'usuario') {
        return [
          {
            events (start, end, timezone, callback) {
              var newstart = start.toISOString()
              var newend = end.toISOString()
              api.request('GET', 'calendario?username=' + slug + '&dtinicio=' + newstart + '&dtfim=' + newend).then(function (response) {
                console.log(response.data)
                callback(response.data)
              }).catch(function (error) {
                console.log(error)
              })
            }
          }
        ]
      }
      if (tipo === 'unidade') {
        return [
          {
            events (start, end, timezone, callback) {
              var newstart = start.toISOString()
              var newend = end.toISOString()
              api.request('GET', 'calendario?unidade=' + slug + '&dtinicio=' + newstart + '&dtfim=' + newend).then(function (response) {
                callback(response.data)
              }).catch(function (error) {
                console.log(error)
              })
            }
          }
        ]
      }
      if (tipo === 'turma') {
        return [
          {
            events (start, end, timezone, callback) {
              var newstart = start.toISOString()
              var newend = end.toISOString()
              api.request('GET', 'calendario?turma=' + slug + '&dtinicio=' + newstart + '&dtfim=' + newend).then(function (response) {
                callback(response.data)
              }).catch(function (error) {
                console.log(error)
              })
            }
          }
        ]
      }
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    isMediador (username) {
      return this.$store.state.user.username === username
    },
    confirmationCancelar () {
      this.showconfirmation = false
      this.reschedulingDetail = null
      this.isrescheduling = false
    },
    confirmationConfirmar () {
      this.reagendarIndividual()
    },
    confirmationFechar () {
      this.confirmationCancelar()
    },
    saveReschedule () {
      this.showconfirmation = true
      this.reschedulingDetail = this.selected
    },
    reagendarIndividual () {
      this.rescheduleinfo.start = this.rescheduleinfo.date + ' ' + this.rescheduleinfo.time
      let timedelta = window.moment.duration(window.moment(this.contextEvent.dt_fim).diff(window.moment(this.contextEvent.dt_inicio)))
      let detalheid = this.reschedulingDetail.id
      var payload = {
        'dt_inicio': this.rescheduleinfo.start,
        'dt_fim': window.moment(this.rescheduleinfo.start).add(timedelta).format('YYYY-MM-DDTHH:mm'),
        'userlist': [this.reschedulingDetail.aluno.username],
        'title': this.reschedulingDetail.aluno.username.concat(' - Reagendamento'),
        'unidade': this.contextEvent.unidade
      }
      api.request('POST', 'aulas/', payload).then((response) => {
            // element = respon      rescheduleinfo: {},      rescheduleinfo: {},      rescheduleinfo: {},      rescheduleinfo: {},      rescheduleinfo: {},se.data
        api.request('DELETE', 'auladetail/' + detalheid + '/').then((response) => {
          this.confirmationCancelar()
          this.$refs.calendar.$emit('refetch-events')
          this.modalClose()
        })
      }).catch(function (error) {
        console.log(error)
      })
    },
    pictureUrl (pic) {
      if (pic === null) {
        return ''
      } else {
        return pic
      }
    },
    eventSelected (event) {
      var nevent = _.cloneDeep(event)
      var mediadores = []
      // console.log(nevent.detalhes)
      nevent.detalhes.forEach((detalhe) => {
        if (detalhe.mediador === null) {
          var semMediador = mediadores.filter(e => e.username === 'semMediador')
          if (semMediador.length <= 0) {
            var mediador = {
              'username': 'semMediador',
              'first_name': 'Sem',
              'last_name': 'Mediador',
              'profilePic': null,
              'detalhes': []
            }
            detalhe.mediador = mediador
            mediador.detalhes.push(detalhe)
            mediadores.push(mediador)
          } else {
            semMediador[0].detalhes.push(detalhe)
          }
        } else {
          var currentMediador = mediadores.filter(e => e.username === detalhe.mediador.username)
          if (currentMediador.length <= 0) {
            mediador = _.cloneDeep(detalhe.mediador)
            mediador.detalhes = [detalhe]
            mediadores.push(mediador)
          } else {
            currentMediador[0].detalhes.push(detalhe)
          }
        }
      })
      nevent.mediadores = mediadores
      this.contextEvent = nevent
      this.showModal = true
    },
    saveDetails (element) {
      var payload = this.selected
      delete payload.aluno
      delete payload.mediador
      var url = 'auladetail/' + payload.id + '/'
      console.log(url)
      api.request('PATCH', url, payload).then(response => {
            // element = response.data
        // console.log(response)
        this.$refs.calendar.$emit('refetch-events')
        this.modalClose()
        this.isediting = false
      })
    },
    rescheduleClass (element) {
      this.rescheduleinfo.start = this.rescheduleinfo.date + ' ' + this.rescheduleinfo.time
      let timedelta = window.moment.duration(window.moment(this.contextEvent.dt_fim).diff(window.moment(this.contextEvent.dt_inicio)))
      var payload = {
        'dt_inicio': this.rescheduleinfo.start,
        'dt_fim': window.moment(this.rescheduleinfo.start).add(timedelta).format('YYYY-MM-DDTHH:mm')
      }
      api.request('PUT', 'aulas/' + element.id + '/', payload).then((response) => {
            // element = response.data
        this.$refs.calendar.$emit('refetch-events')
        this.modalClose()
        this.rescheduleinfo = {}
      }).catch(function (error) {
        console.log(error)
      })
    },
    startEdit (detalhes) {
      this.selected = _.cloneDeep(detalhes)
      this.isediting = true
    },
    startReschedule (detalhes) {
      this.selected = _.cloneDeep(detalhes)
      this.isrescheduling = true
    },
    modalClose () {
      this.contextAula = {}
      this.contextEvent = {}
      this.selected = {}
      this.reschedulingall = false
      this.showModal = false
    }
  }
}
</script>

<style lang="scss">
.fc-view-container{
    border: solid 1px #ddd;
}
.student-pic{
    padding-left: 0;
}
.avatar{
    max-width: 70px;
}


.modal-dialog{
    overflow-y: initial !important;
}
.modal-body{
    max-height: 400px;
    overflow-y: auto;
}

.classShow{
    .row{
        padding: 0 40px;
    }
    .teacherName{
        display: inline-block;
        margin-left: 20px;
    }
    hr{
        margin-top: -20px;
        margin-bottom: 40px;
        margin-left: 40px;
        margin-right: 40px;
    }
    .panel-body{
        .row{
            padding: 0 20px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Calendario/Calendario.vue